<div>
    <input #questionInput placeholder="Question" (keyup)="onQuestionEnter(questionInput)">
    <input #scoreInput placeholder="Score" (keyup)="onScoreEnter(scoreInput)">
    <textarea #details (keyup)="onDetailsEnter(details)"></textarea>
    <input #correctAnswer (keyup)="onCorrectAnswerEnter(correctAnswer)" placeholder="Correct Answer">
</div>